import React, { useMemo } from "react";
import "./SuperChatAIOrderTable.scss";

// Format date as "Mon DD, YYYY" (e.g., "Apr 14, 2026")
const formatSubmittedDate = (dateString) => {
  if (!dateString) return "--";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "--";
    
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
  } catch {
    return "--";
  }
};

// Table component for displaying Order Creation Failures
export const CreationFailuresTable = ({ failures }) => {
  // Define the column order matching the design
  const columns = [
    "engagementName",
    "analyserTypes",
    "superRegion",
    "region",
    "noOfAnalyserRequired",
    "submittedBy",
    "submittedDate",
    "periodOfTesting",
  ];

  // Create a mapping for display names
  const getDisplayName = (key) => {
    const displayNames = {
      engagementName: "Engagement name",
      analyserTypes: "Analyzer",
      superRegion: "Super Region",
      region: "Region",
      noOfAnalyserRequired: "No. of Analyzers Required",
      submittedBy: "Submitted By",
      submittedDate: "Submitted Date",
      periodOfTesting: "Period of Testing",
    };
    return displayNames[key] || key.charAt(0).toUpperCase() + key.slice(1);
  };

  // Transform API failures data to table rows
  const transformedFailures = useMemo(() => {
    if (!failures || failures.length === 0) return [];
    
    return failures.map((failure) => ({
      failureId: failure.failureId,
      notificationId: failure.notificationId,
      engagementName: failure.engagementName ||  "--",
      analyserTypes: failure.analyserTypes || "--", // Not available in API response yet
      superRegion: failure.region || "--",
      region: failure.country || "--",
      noOfAnalyserRequired: failure.numberOfAnalyser || "--", // Not available in API response yet
      submittedBy: failure.submittedBy || "--",
      submittedDate: formatSubmittedDate(failure.createdOn), 
      periodOfTesting: failure.periodOfTesting || "--", // Not available in API response yet
    }));
  }, [failures]);

  if (!failures || failures.length === 0) {
    return (
      <div className="super-chat-ai-order-table creation-failures-table">
        <div className="no-data">No order creation failures found.</div>
      </div>
    );
  }

  return (
    <div className="super-chat-ai-order-table creation-failures-table">
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col}>
                <div className="th-content">
                  <span className="th-text">{getDisplayName(col)}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {transformedFailures.map((row, index) => (
            <tr key={row.failureId || index}>
              <td>{row.engagementName}</td>
              <td>{row.analyserTypes}</td>
              <td>{row.superRegion}</td>
              <td>{row.region}</td>
              <td>{row.noOfAnalyserRequired}</td>
              <td>{row.submittedBy}</td>
              <td>{row.submittedDate}</td>
              <td>{row.periodOfTesting}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CreationFailuresTable;
